module.exports = __webpack_public_path__ + "static/media/swap_bg.aa07e19d.jpg";